import React, { useEffect } from 'react';
import { withPlaceholder } from '@sitecore-jss/sitecore-jss-react';

const defaultValues = {
  itemsMobile: 1,
  itemsTabletPortrait: 2,
  itemsTabletLandscape: 3,
  itemsDesktop: 4,
};

const Carousel = ({ rendering, fields, carouselItems }) => {
  const tnsEvents = ['indexChanged', 'newBreakpointStart', 'newBreakpointEnd'];
  const prevText = '<span class="vds-visually-hidden">Previous</span>';
  const nextText = '<span class="vds-visually-hidden">Next</span>';
  const tnsConfig = {
    container: `[data-carouselid="${rendering.uid}"] .vds-auto-layout__inner`,
    items: fields?.itemsMobile?.value || defaultValues.itemsMobile,
    gutter: 16,
    autoplay: false,
    loop: false,
    mouseDrag: true,
    startIndex: 0,
    autoplayButtonOutput: false,
    arrowKeys: true,
    navPosition: 'bottom',
    slideBy: 'page',
    preventScrollOnTouch: 'auto',
    controls: true,
    controlsPosition: 'bottom',
    controlsText: [prevText, nextText],
    responsive: {
      768: {
        items: fields?.itemsTabletPortrait?.value || defaultValues.itemsTabletPortrait,
      },
      900: {
        items: fields?.itemsTabletLandscape?.value || defaultValues.itemsTabletLandscape,
      },
      1200: {
        items: fields?.itemsDesktop?.value || defaultValues.itemsDesktop,
      },
      1440: {
        items: fields?.itemsDesktop?.value || defaultValues.itemsDesktop,
      },
    },
  };

  const inactiveChildAnchors = container => {
    const carouselContainer = document.querySelector(container);
    const items = carouselContainer?.querySelectorAll('.tns-item');

    if (items) {
      items.forEach(item => {
        let itemChildAnchors = item.querySelectorAll('a, button');

        if (itemChildAnchors) {
          itemChildAnchors.forEach(itemChildAnchor => {
            if (item.classList.contains('tns-slide-active')) {
              itemChildAnchor.removeAttribute('tabindex');
            } else {
              itemChildAnchor.setAttribute('tabindex', '-1');
            }
          });
        }
      });
    }
  };

  useEffect(() => {
    const init = async () => {
      let tns = null;
      if (typeof window !== 'undefined' && carouselItems?.length > 1) {
        const tnsModule = await import('tiny-slider');
        tns = tnsModule.tns;
        const autoLayout = tns(tnsConfig);
        inactiveChildAnchors(tnsConfig.container);
        for (const event of tnsEvents) {
          autoLayout.events.on(event, () => inactiveChildAnchors(tnsConfig.container));
        }
      }
    };
    init();
  }, []);

  return (
    <div
      className="vds-auto-layout vds-auto-layout--carousel"
      data-testid="carousel"
      data-items_mobile={fields?.itemsMobile?.value || 1}
      data-items_tablet_p={fields?.itemsTabletPortrait?.value || 2}
      data-items_tablet_l={fields?.itemsTabletLandscape?.value || 3}
      data-items_desktop={fields?.itemsDesktop?.value || 4}
      data-carouselid={rendering.uid}
    >
      <div className="vds-auto-layout__inner">{carouselItems}</div>
    </div>
  );
};

export default withPlaceholder('carouselItems')(Carousel);
